import isEmpty from 'lodash/isEmpty';
import { instBundle } from '@/axios';

const axiosAdmin2 = instBundle.axiosAdmin2;

export default {
	state: {
		adCodeTable: {},
		refTypeLink: {
			commonbanner: '/advertisement/main-banner-manage',
			monthlyProduct: '/product/monthly-product/edit/${refId}',
			brandbanner: '/advertisement/recommend-manage',
			brand: '/advertisement/recommend-manage',
			brandTypeBanner: '/brand/brand_type',
			pouch: '/cast/${refId}',
			event: '/events/modifies/${refId}',
			hotediter_v2: '/advertisement/editor-product/list',
			popup: '/manage/init-popup/modify/${refId}',
			splash_list: '/manage/splash-modify/${refId}',
			event_ad: '/advertisement/ad?id=${refId}&openform=true',
			mainLineBanner: '/advertisement/line-banner-modify/${refId}',
			eventLineBanner: '/advertisement/event-line-modify/${refId}',
			productLineBanner: '/advertisement/product-line-modify/${refId}',
			recommend_brand: '/advertisement/brand-recommend-modify/${refId}',
		},
	},
	getters: {
		adCodeList(state) {
			const codeTable = state.adCodeTable;
			return Object.keys(codeTable).map(id => ({
				id,
				name: codeTable[id].label,
			}));
		},
	},
	actions: {
		async initData({ state }) {
			try {
				if (isEmpty(state.adCodeTable)) {
					const { data } = await axiosAdmin2.get('/api/ad/ad-code');
					state.adCodeTable = data.reduce((acc, cur) => {
						acc[cur.adCode] = cur;
						return acc;
					}, {});
				}
			} catch (err) {
				console.error(err);
				alert(
					'광고집계관련 데이터를 초기화하는데 문제가 발생했습니다. 개발팀에 문의하세요.'
				);
			}
		},
	},
	namespaced: true,
};
